module.exports = __webpack_public_path__ + "assets/a9d97e592db2146a19773bca5275e7c6.json";